
import { Component, Prop, Vue } from "vue-property-decorator"
import { StringHelper } from "~/utils/StringHelper"

@Component
export default class CopyTextField extends Vue {
  @Prop(String) readonly value!: string
  @Prop(String) readonly label!: string
  @Prop({ type: Number, default: 40 }) readonly height!: number
  @Prop({ type: String, default: "" }) readonly className!: string

  copyAlert = false
  alertTimeout = 1000

  get displayValue(): string {
    return `${this.value ?? ""}`
  }

  get copySuccessMessage(): string {
    return this.label ? `${this.label} Copied!` : "Copied!"
  }

  async clickCopy() {
    try {
      await StringHelper.copyToClipBoard(this.displayValue)
      this.copyAlert = true
    } catch (error) {
      this.$toast.show("Unable to copy to clipboard", { icon: "error" })
    }
  }
}
